/**
 * Enum representing the types of modals that can be opened.
 * Add modals here if you need them globally accessible.
 */
export enum ModalType {
  UPGRADE = 'UPGRADE',
}

/**
 * Current modal state
 */
export type CurrentModalState = {
  type: ModalType;
  trackingSource?: string;
};

/**
 * Context value type for managing global modals.
 */
export type GlobalModalContext = {
  currentModal: ModalType | null;
  openModal: (props: CurrentModalState) => void;
  closeModal: () => void;
  registerModals: (registeredModals: ModalType[]) => void;
};

/**
 * Props required for the useGlobalModal hook.
 */
export type GlobalModalProps<T extends ModalType> = {
  trackingSource?: string;
  registeredModals: T[];
};

/**
 * Return type for the useGlobalModal hook.
 */
export type GlobalModalReturn<T extends ModalType> = {
  openModal: (type: T) => void;
  closeModal: () => void;
  currentModal: ModalType | null;
};
